import request from '@/utils/request'

export function login(data) {
  return request({
    url: 'c=entry&m=lanniu_rownumber&do=login',
    method: 'post',
    data
  })
}

export function getInfo(token) {
  return request({
    url: 'c=entry&m=lanniu_rownumber&do=user_info',
    method: 'get',
    params: { token }
  })
}

export function logout() {
  return request({
    url: 'c=entry&m=lanniu_rownumber&do=logout',
    method: 'post'
  })
}
